import React from 'react';

interface SubScoreProps {
    label: string,
    score: string,
}

function SubScore({label, score}: SubScoreProps) {
    return (
        <>
            <small>
                {label}
            </small>
            <span className="gb--label gb--label-blue">
                {score}
            </span>
        </>
    );
}

export default SubScore;